<template>
    <v-row no-gutters>
        <v-col class="pe-1">
            <v-autocomplete
                :items="items"
                item-value="id"
                item-text="name"
                label="Item"
                dense
                outlined
                hide-details="auto"
                v-model="form.item_id"
                :rules="[isRequired]"
            >
            </v-autocomplete>
        </v-col>
        <v-col cols="12" md="2" class="pe-1">
            <v-autocomplete
                :items="measure_units"
                item-value="id"
                item-text="name"
                label="Measure Unit"
                v-model="form.measure_unit_id"
                dense
                outlined
                hide-details="auto"
                :rules="[isRequired]"
            >
            </v-autocomplete>
        </v-col>
        <v-col cols="12" md="1" class="pe-1">
            <v-text-field
                v-model="form.quantity"
                label="Quantity"
                dense
                outlined
                hide-details="auto"
                :rules="[isRequired, isNumeric]"
            >
            </v-text-field>
        </v-col>
        <v-col cols="12" md="1" class="pe-1">
            <v-text-field
                v-model="form.price"
                label="Price"
                dense
                outlined
                hide-details="auto"
                :rules="[isRequired, isNumeric]"
            >
            </v-text-field>
        </v-col>
        <v-col cols="12" md="2">
            <div class="d-flex align-center"> 
                <v-text-field
                    :value="total"
                    label="Total"
                    disabled
                    dense
                    outlined
                    hide-details="auto"
                >
                </v-text-field>
                <v-btn icon @click="delete_line">
                    <v-icon> mdi-close </v-icon>
                </v-btn>   
            </div>
        </v-col>
    </v-row>
</template>

<script>
import { isRequired, isNumeric } from './../../utils/validations'
import { mapGetters } from "vuex";
export default {
    data() {
        return {
            form: { ...this.value },
            
        };
    },
    props: {
        value: Object,
    },
    computed: {
        ...mapGetters({
            items: "sales/item/items",
        }),
        measure_units() {
            var item = this.items.find((item) => item.id == this.form.item_id);
            if (item) {
                return this.items.find((item) => item.id == this.form.item_id)
                    .measure_units;
            }
            return [];
        },
        total() {
            let total = this.form.price * this.form.quantity;
            return isNaN(total) ? 0 : total;
        },
    },
    watch: {
        form: {
            handler(form) {
                var total = this.total;
                this.$emit("input", { ...form, total });
            },
            deep: true,
        },
    },
    methods: {
        delete_line() {
            this.$emit("delete_line");
        },
        isRequired,
        isNumeric,
    },
};
</script>
